import { Duration, Instant, type TemporalAmount } from "@js-joda/core";
import Cookies, { type CookieAttributes } from "js-cookie";
import { useMemo } from "react";

const DEFAULT_COOKIE_OPTIONS: CookieAttributes = { path: "/" };

export const useCookieState = <T = unknown>(
  cookieName: string,
  options?: CookieAttributes,
) => {
  return useMemo(
    () => ({
      get: () => {
        return Cookies.get(cookieName);
      },
      set: (newValue: string) => {
        Cookies.set(cookieName, newValue, {
          expires: new Date(Instant.now().plus(Duration.ofHours(1)).toString()),
          ...DEFAULT_COOKIE_OPTIONS,
          ...options,
        });
      },
      remove: () => {
        Cookies.remove(cookieName, { ...DEFAULT_COOKIE_OPTIONS, options });
      },
      renew: (renewInterval: TemporalAmount = Duration.ofHours(1)) => {
        Cookies.set(cookieName, Cookies.get(cookieName), {
          ...DEFAULT_COOKIE_OPTIONS,
          ...options,
          expires: new Date(Instant.now().plus(renewInterval).toString()),
        });
      },
    }),
    [cookieName, options],
  );
};
